// @core/api/endpoints/workflow/resume_schedule.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  PipelineScheduleResponse,
  ResumeScheduleRequest,
} from '../../../types/workflow';

const BASE_PATH = '/workflow';

/**
 * Resume schedule
 * Resumes a paused schedule. The next_run_at is recalculated.
 */
export async function ResumeSchedule(
  schedule_id: string,
  data: ResumeScheduleRequest,
  options?: RequestOptions
): Promise<PipelineScheduleResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/workflows/schedules/:schedule_id/resume`;
  requestPath = requestPath.replace(':schedule_id', encodeURIComponent(schedule_id));
  const requestOptions = options;
  return client.post<PipelineScheduleResponse>(requestPath, data, requestOptions);
}
